import React, { useState, useEffect } from 'react';
import * as htmlToImage from 'html-to-image';
import download from 'downloadjs';

interface DownloadButtonProps {
  previewRef: React.RefObject<HTMLDivElement>;
}

const DownloadButton: React.FC<DownloadButtonProps> = ({ previewRef }) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (previewRef.current) {
      setIsReady(true);
    }
  }, [previewRef]);

  const handleDownload = () => {
    const node = previewRef.current;

    if (node) {
      // 1回目の実行
      htmlToImage.toPng(node)
        .then(() => {
          // 2回目の実行
          return htmlToImage.toPng(node);
        })
        .then(() => {
          // 3回目の実行
          return htmlToImage.toPng(node);
        })
        .then((dataUrl) => {
          // 3回目の結果をダウンロード
          download(dataUrl, 'poster.png');
        })
        .catch((error) => {
          console.error('Error generating image:', error);
        });
    } else {
      console.log("Element not found");
    }
  };

  return (
    <button
      type="button"
      onClick={handleDownload}
      className={`mt-4 p-2 rounded ${isReady ? 'bg-green-500 text-white' : 'bg-gray-300 text-gray-500'}`}
      disabled={!isReady}
    >
      ポスターをダウンロード
    </button>
  );
};

export default DownloadButton;
